import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.5 8L7.5 12L11.5 16",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .5,
		d: "M15.5 8L11.5 12L15.5 16",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCollapse;
